import { Component, Input, OnInit, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

export interface TableColumn {
  field: string;
  label: string;
  visible: boolean;
  order: number;
  filterValue?: string;
  specialOnly?: boolean;   // se visibile solo se canSpecial() === true
  updatableOnly?: boolean; // se visibile solo se canUpdate() === true
  sortable?: boolean;
  width?: string;
  withGeofencingTourBigOrderOnly?: boolean;  // se visibile solo se canWithGeofencingTourBigOrderOnly() === true
  specialOrWithGeofencingTourBigOrderOnly?: boolean; // se visibile solo se canWithGeofencingTourBigOrderOnly() === true || canSpecial() === true
  sendDDTOnly?: boolean;
  notDealer?: boolean; // NON visibile se è dealer
}

@Component({
  selector: 'column-customize',
  standalone: true,
  templateUrl: './column-customize.component.html',
  styleUrls: ['./column-customize.component.scss'],
  imports: [FormsModule, CommonModule, DragDropModule]
})
export class ColumnCustomizeComponent {
  @Input() columns: TableColumn[] = [];
  @Input() storageKey: string = 'defaultTableConfig';
  @Output() columnsChange = new EventEmitter<TableColumn[]>();

  tempColumns: TableColumn[] = [];
  showDropdown = false;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    // const saved = localStorage.getItem(this.storageKey);
    // if (saved) {
    //   this.columns = JSON.parse(saved);
    // }
    // this.columns.sort((a,b) => a.order - b.order);
    this.tempColumns = JSON.parse(JSON.stringify(this.columns));
  }

  toggleColumn(col: TableColumn) {
    col.visible = !col.visible;
  }

  drop(event: CdkDragDrop<TableColumn[]>) {
    moveItemInArray(this.tempColumns, event.previousIndex, event.currentIndex);
    this.tempColumns.forEach((c,i) => c.order = i+1);
  }

  saveUserConfig() {
    this.columns = JSON.parse(JSON.stringify(this.tempColumns));
    localStorage.setItem(this.storageKey, JSON.stringify(this.columns));
    this.columnsChange.emit(this.columns);
    this.showDropdown = false;
  }

  resetConfig() {
    this.tempColumns = JSON.parse(JSON.stringify(this.columns));
    this.showDropdown = false;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  // chiude il dropdown se clicchi fuori
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: any) {
    if (!this.el.nativeElement.contains(targetElement)) {
      this.showDropdown = false;
    }
  }
}
